export default __webpack_public_path__ + "static/media/category-ring.d0e9566e.svg";